import { callGetApi, callPutApi, callPostApi, callDeleteApi } from '../apiCallerProxy';
import { pushReportApiFactory } from './pushReportApiFactory';

export * from './usePushReportApi';

export const pushReportApi = pushReportApiFactory({
    callPutApi,
    callPostApi,
    callDeleteApi,
    callGetApi,
});
